import store from '@/store';
import Lockr from 'lockr';
import axios from 'axios';
import Cookies from 'js-cookie';
import { getCookiesDomain } from '@/utils/index.js';
var cache = {
    /**
     * 载入全部登陆信息
     */
    loadingCache: function () {
        if (localStorage.getItem('AdminToken') && !axios.defaults.headers['Admin-Token']) {
            /** 将用户信息放入缓存 */
            var userInfo = Lockr.get('loginUserInfo');
            if (userInfo) {
                store.commit('SET_USERINFO', userInfo);
            }
        }
        store.commit('SET_APPNAME', Lockr.get('systemName'));
        store.commit('SET_APPLOGO', Lockr.get('systemLogo'));
    },
    /**
     * 请求和更新登录缓存
     */
    updateAxiosCache: function (data) {
        axios.defaults.headers['Admin-Token'] = (data && data.token) || localStorage.getItem('AdminToken');
        axios.defaults.headers['channel'] = (data && data.channel) || localStorage.getItem('channel');
        if (data && data.token) {
            localStorage.setItem('AdminToken', data.token);
        }
        if (data && data.channel) {
            localStorage.setItem('channel', data.channel);
        }
    },
    updateAxiosHeaders: function (data) {
        var newToken = (data && data.token) || localStorage.getItem('AdminToken');
        var newChannel = (data && data.channel) || localStorage.getItem('channel');
        if (data && data.token) {
            localStorage.setItem('AdminToken', data.token);
        }
        if (data && data.channel) {
            localStorage.setItem('channel', data.channel);
        }
        if (newToken && axios.defaults.headers['Admin-Token'] !== newToken) {
            axios.defaults.headers['Admin-Token'] = newToken;
            return true; // token 变动
        }
        else if (newChannel && axios.defaults.headers['channel'] !== newChannel) {
            axios.defaults.headers['channel'] = newChannel;
            return true; // channel 变动
        }
    },
    /**
     * 移除登录信息
     * @param {*}
     */
    rmAxiosCache: function () {
        Cookies.remove('AdminToken', { domain: getCookiesDomain() });
        Cookies.remove('channel', { domain: getCookiesDomain() });
        Lockr.rm('AdminToken');
        Lockr.rm('channel');
    }
};
export default cache;
